var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComputerLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 12,
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 2C1 1.44772 1.44772 1 2 1H13C13.5523 1 14 1.44772 14 2V8.66667C14 9.21895 13.5523 9.66667 13 9.66667H2C1.44772 9.66667 1 9.21895 1 8.66667V2Z",
  stroke: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.29004 11.1832H9.97004",
  stroke: "white",
  strokeLinecap: "round"
})));
export { SvgComputerLight as ReactComponent };
export default __webpack_public_path__ + "static/media/computerLight.12947ce9.svg";